export default __webpack_public_path__ + "static/media/professional.fc434713.jpg";